import React from "react";
import { Typography } from "antd";

const { Paragraph, Link } = Typography;

const ExpandableRemarks = ({
  text,
  rows = 2,
  style,
  emptyText = "-",
}) => {
  const value = text?.trim();

  if (!value) {
    return <span>{emptyText}</span>;
  }

  return (
    <Paragraph
      style={{ marginBottom: 0, wordBreak: "break-word", ...style }}
      ellipsis={{
        rows,
        expandable: "collapsible",
        symbol: (expanded) => (
          <Link style={{ fontSize: 12, marginLeft: 4 }}>
            {expanded ? "less" : "more"}
          </Link>
        ),
      }}
    >
      {value}
    </Paragraph>
  );
};

export default ExpandableRemarks;
